export const DsaTarget = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Ad Group Dynamic Search Ad Target',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
  },
};
